<template lang="pug">
form.container.w-50
    h3.mb-1 Biobank Editor
    p.text-muted.mb-3 Version {{appVersion}}
    .alert.alert-info Logging in...
    .alert.alert-danger(v-if="oidcCallbackError") {{oidcCallbackError}}
</template>

<script>
import {buildOidcBrowserRedirectUrl, completeOidcLogin, getSession, isOrdsDeployment} from "../api";
import buildVersion from "../generated-build-version.json";

export default {
    data() {
        const runtimeConfig = (typeof window !== "undefined" && window.__APP_CONFIG__)
            ? window.__APP_CONFIG__
            : null;
        const isOrdsRuntime = !!(runtimeConfig && runtimeConfig.ordsSchema);
        return {
            appVersion: isOrdsRuntime ? buildVersion.versionOrds : buildVersion.versionNode,
            oidcCallbackError: null
        };
    },
    created() {
        this.handleOidcCallback();
    },
    methods: {
        navigateToHome() {
            return this.$router.replace("/").catch(err => {
                const message = String(err && err.message || "");
                if (!message.includes('Redirected when going from')) throw err;
            });
        },
        replaceRoute(route) {
            return this.$router.replace(route).catch(err => {
                const message = String(err && err.message || "");
                if (!message.includes('Redirected when going from')) throw err;
            });
        },
        updateLocalSession(user) {
            if (typeof sessionStorage !== "undefined") {
                sessionStorage.removeItem("oidc_login_in_progress");
            }
            localStorage.removeItem("oidc_login_started_at_ms");
            localStorage.setItem("last_login_method", "oidc");
            localStorage.setItem("user", user.email);
            localStorage.setItem("is_admin", user.is_admin ? "1" : "0");
            localStorage.setItem("allowed_domains", JSON.stringify(user.allowed_domains || []));
            if (user.biobank) localStorage.setItem("biobank", user.biobank);
            else localStorage.removeItem("biobank");
        },
        recoverSessionOrFail(fallbackMessage) {
            return getSession()
            .then(user => {
                this.updateLocalSession(user);
                return this.navigateToHome();
            })
            .catch(() => {
                this.oidcCallbackError = fallbackMessage || "OIDC login failed";
            });
        },
        handleOidcCallback() {
            const code = this.$route && this.$route.query ? this.$route.query.code : "";
            const state = this.$route && this.$route.query ? this.$route.query.state : "";
            const hasSession = this.$route && this.$route.query && this.$route.query.session === "1";
            const oidcError = this.$route && this.$route.query ? this.$route.query.oidc_error : "";
            if (oidcError) {
                if (typeof sessionStorage !== "undefined") {
                    sessionStorage.removeItem("oidc_login_in_progress");
                }
                localStorage.removeItem("post_login_redirect_pending");
                this.replaceRoute({path: "/login", query: {oidc_error: oidcError}});
                return;
            }
            if (hasSession) {
                getSession()
                .then(user => {
                    this.updateLocalSession(user);
                    return this.navigateToHome();
                })
                .catch(() => {
                    return this.recoverSessionOrFail("OIDC login failed");
                });
                return;
            }
            if (!code) {
                if (typeof sessionStorage !== "undefined") {
                    sessionStorage.removeItem("oidc_login_in_progress");
                }
                localStorage.removeItem("post_login_redirect_pending");
                this.replaceRoute("/login");
                return;
            }

            this.oidcCallbackError = null;
            const redirectUri = window.location.origin + window.location.pathname;
            if (!isOrdsDeployment()) {
                window.location.replace(buildOidcBrowserRedirectUrl(code, state, redirectUri));
                return;
            }
            completeOidcLogin(code, state, redirectUri)
            .then(user => {
                if (!user || user.success === false || !user.email) {
                    throw new Error(user && user.message ? user.message : "OIDC login failed");
                }
                this.updateLocalSession(user);
                return this.navigateToHome();
            })
            .catch(err => {
                if (typeof sessionStorage !== "undefined") {
                    sessionStorage.removeItem("oidc_login_in_progress");
                }
                const message = err && err.message ? err.message : "OIDC login failed";
                return this.recoverSessionOrFail(message);
            });
        }
    }
}
</script>
